<template>
  <div style="background-color: #f5f7fa;" class="systembody">
    <nav-bar></nav-bar>
    <PermissionsComp />
  </div>
</template>
<script>
import PermissionsComp from '@/components/admin/permissions/PermissionsComp'
import Auth from '../../services/auth.service'
import NavBar from '@/components/widgets/navBar.vue'

export default {
  components: {
    PermissionsComp,
    NavBar
  },
  mounted() {
    let auth = Auth.checkAuth();
    let role = Auth.getUserRole();
    if (!auth || (role !== "admin" && role !== "superAdmin" && role !== "agent")) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>
<style scoped>
.systembody {
  height: 100vh;
  /* Adjusted height to fit below the navbar */
  overflow-y: auto;
  overflow-x: hidden;
  background: #fbfbfb;
  padding: 10px;
}

.systembody::-webkit-scrollbar {
  width: 10px;
  /* Adjust the width of the scrollbar */
}

/* Customizes the scrollbar track (space to scroll) */
.systembody::-webkit-scrollbar-track {
  background-color: #FFFFFF;
  /* Sets the track color to white */
}

/* Customizes the scrollbar thumb (the draggable element) */
.systembody::-webkit-scrollbar-thumb {
  background-color: rgb(219, 218, 218);
  /* Sets the thumb color to blue */
  border-radius: 3px;
  /* Optional: Adds rounded corners to the thumb */
}
</style>